import { useState } from "react";
import DeleteItemIcon from "../../../assets/delete-item.svg";
import EditItemIcon from "../../../assets/edit-item.svg";
import SortableTh from "../../shared/SortableTh";

// Summarize a role's API permissions by their group, so the list shows which
// areas a role covers (and how many permissions in each) before you open it.
// Roles come with `permission` fully populated, so each item carries `.group`.
const MAX_GROUP_BADGES = 10;
const groupSummary = (role) => {
    const perms = Array.isArray(role?.permission) ? role.permission : [];
    const counts = {};
    for (const p of perms) {
        const g = (p && typeof p.group === 'string' && p.group.trim()) ? p.group.trim() : 'other';
        counts[g] = (counts[g] || 0) + 1;
    }
    // Most-used groups first, then alphabetical.
    return Object.entries(counts).sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]));
};

// The group badges for one role. Shows all of them; when there are a lot it
// collapses to the first few behind a "+N more" button that expands them all
// inline (and a "show less" to collapse again).
function RoleGroups({ role }) {
    const [expanded, setExpanded] = useState(false);
    const groups = groupSummary(role);
    if (!groups.length) { return <span className="text-muted">—</span>; }

    const collapsed = !expanded && groups.length > MAX_GROUP_BADGES;
    const shown = collapsed ? groups.slice(0, MAX_GROUP_BADGES) : groups;
    const rest = groups.length - shown.length;

    return (
        <div className="d-flex flex-wrap gap-1 align-items-center">
            {shown.map(([g, n]) => (
                <span key={g} className="badge bg-light text-dark border" style={{ fontWeight: 500 }}>
                    {g} <span className="text-muted">{n}</span>
                </span>
            ))}
            {collapsed && (
                <button
                    type="button"
                    className="badge bg-secondary border-0"
                    style={{ cursor: 'pointer' }}
                    onClick={() => setExpanded(true)}
                >
                    +{rest} more
                </button>
            )}
            {expanded && groups.length > MAX_GROUP_BADGES && (
                <button
                    type="button"
                    className="badge bg-outline-secondary border text-muted"
                    style={{ cursor: 'pointer', background: 'transparent' }}
                    onClick={() => setExpanded(false)}
                >
                    show less
                </button>
            )}
        </div>
    );
}

const ViewRoles = ({
                       data,
                       sort,
                       order,
                       onSort,
                       editHandler,
                       deleteHandler
                   }) => {
    // Sort the data by role type
    // const sortedData = data?.data?.sort((a, b) => (a.type && b.type ? a.type.localeCompare(b.type) : 0));

    return (
        <div className="table-responsive bg-light p-3 mt-2">
            <table className="table table-sm table-border">
                <thead className="border-0">
                <tr>
                    <SortableTh label='Name' field='name' sort={sort} order={order} onSort={onSort}/>
                    <SortableTh label='Type' field='type' sort={sort} order={order} onSort={onSort}/>
                    <th>Description</th>
                    <th>Key groups</th>
                    <th>Actions</th>
                </tr>
                </thead>

                <tbody>
                {data?.data?.map((role) => (
                    <tr key={role._id}>
                        <td>{role.name}</td>
                        <td>{role.type}</td>
                        <td>{role.description}</td>
                        <td style={{ maxWidth: 440 }}>
                            <RoleGroups role={role} />
                        </td>
                        <td>
                            <div className="btn-group">
                                <button
                                    className="btn"
                                    onClick={() => editHandler(role)}
                                    data-bs-toggle="modal"
                                    data-bs-target="#roleModal"
                                >
                                    <img src={EditItemIcon} alt="Edit"
                                         className="icon-img action-icons-img"/>
                                </button>

                                <button
                                    className="btn"
                                    onClick={() => deleteHandler(role._id)}
                                >
                                    <img src={DeleteItemIcon} alt="Delete"
                                         className="icon-img action-icons-img"/>
                                </button>
                            </div>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default ViewRoles;
